import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dropdown-wrapper"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["value"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "dropdown-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.29282 6.29289L7.99992 10L11.707 6.29289L10.2928 4.87868L7.99992 7.17157L5.70703 4.87868L4.29282 6.29289Z",
  fill: "#E80033"
})], -1);
const _hoisted_5 = {
  class: "dropdown-wrapper"
};
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = ["value"];
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "dropdown-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.29282 6.29288L7.99992 9.99998L11.707 6.29288L10.2928 4.87866L7.99992 7.17156L5.70703 4.87866L4.29282 6.29288Z",
  fill: "#E80033"
})], -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.9219 2.32642L15.0031 5.24527L14.2959 5.95237L15.0031 6.65948L17.9219 9.57833L19.3361 8.16412L18.1244 6.95237H22.2776V4.95237H18.1244L19.3361 3.74063L17.9219 2.32642ZM8.68301 7.04709C8.68301 6.59185 9.05206 6.22281 9.5073 6.22281C9.96253 6.22281 10.3316 6.59185 10.3316 7.04709V13.2496V14.2496H10.3316V14.9794H12.3316V13.9794V12.1551C12.3316 11.6998 12.7007 11.3308 13.1559 11.3308C13.6111 11.3308 13.9802 11.6998 13.9802 12.1551V13.6145V13.9794V14.7091V14.9794V15.7091H15.9802V14.9794V14.7091V13.9794V13.6145C15.9802 13.1593 16.3492 12.7902 16.8045 12.7902C17.2597 12.7902 17.6287 13.1593 17.6287 13.6145V20.5468V21.5468H19.6287V20.5468V13.6145C19.6287 12.0547 18.3643 10.7902 16.8045 10.7902C16.4256 10.7902 16.0641 10.8648 15.734 11.0001C15.2925 10.0162 14.3042 9.3308 13.1559 9.3308C12.8691 9.3308 12.5924 9.37354 12.3316 9.45299V7.04709C12.3316 5.83938 11.5735 4.80872 10.5073 4.40495V4.22281H9.5073C7.94749 4.22281 6.68301 5.48728 6.68301 7.04709V13.3603C5.84124 12.1785 4.22698 11.8145 2.95162 12.5508C1.58556 13.3395 1.12403 15.0904 1.9238 16.45L4.63194 21.0538L5.13896 21.9157L6.86283 20.9017L6.35581 20.0398L3.64767 15.4359C3.41116 15.0338 3.54764 14.5161 3.95162 14.2828C4.34611 14.0551 4.85025 14.1833 5.08793 14.5719L6.82994 17.42L8.68301 16.8982V7.04709Z",
  fill: "#E80033"
})], -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "phone-contact__table-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "table-header-cell"
}, "Phone Number"), /*#__PURE__*/_createElementVNode("div", {
  class: "table-header-cell"
}, "Type"), /*#__PURE__*/_createElementVNode("div", {
  class: "table-header-cell"
}, "Countries")], -1);
const _hoisted_11 = {
  class: "table-cell phone"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "phone-icon",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M9.34988 13.81L11.4199 11.74C11.4199 11.74 11.4499 11.72 11.4599 11.72C11.4799 11.72 11.4899 11.72 11.4999 11.72C12.3699 12.01 13.3099 12.16 14.2799 12.16C14.3299 12.16 14.3699 12.2 14.3699 12.25V14.77C14.3699 14.77 14.3299 14.86 14.2799 14.86C7.84988 14.87 2.62988 9.65 2.62988 3.22C2.62988 3.17 2.66988 3.13 2.71988 3.13H5.24988C5.24988 3.13 5.33988 3.17 5.33988 3.22C5.33988 4.19 5.48988 5.12001 5.77988 5.99001C5.77988 6.01001 5.77988 6.03 5.77988 6.04C5.77988 6.05 5.76988 6.07 5.74988 6.09L3.70988 8.13",
  stroke: "#E80033"
})], -1);
const _hoisted_13 = ["href"];
const _hoisted_14 = {
  class: "table-cell type"
};
const _hoisted_15 = {
  class: "table-cell countries"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
    to: ".phone-contact__dropdown"
  }, [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("select", {
    "aria-label": $options.getLabel('select.region'),
    class: "dropdown-select",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selectedRegion = $event)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.regions, (region, index) => {
    return _openBlock(), _createElementBlock("option", {
      key: index,
      value: region
    }, _toDisplayString(region), 9, _hoisted_3);
  }), 128))], 8, _hoisted_2), [[_vModelSelect, $data.selectedRegion]]), _hoisted_4]), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("select", {
    "aria-label": $options.getLabel('select.country'),
    class: "dropdown-select",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.selectedCountry = $event)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredCountries, country => {
    return _openBlock(), _createElementBlock("option", {
      key: country,
      value: country
    }, _toDisplayString(country), 9, _hoisted_7);
  }), 128))], 8, _hoisted_6), [[_vModelSelect, $data.selectedCountry]]), _hoisted_8]), _createElementVNode("div", {
    class: "swipe-instruction",
    onTouchstart: _cache[2] || (_cache[2] = (...args) => _ctx.handleSwipeStart && _ctx.handleSwipeStart(...args)),
    onTouchend: _cache[3] || (_cache[3] = (...args) => _ctx.handleSwipeEnd && _ctx.handleSwipeEnd(...args))
  }, [_hoisted_9, _createTextVNode(" Swipe to see the table ")], 32)])), (_openBlock(), _createBlock(_Teleport, {
    to: ".phone-contact__table"
  }, [_hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredPhoneNumbers, (phoneNumber, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "phone-contact__table-row"
    }, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("a", {
      href: `tel:${phoneNumber.phone}`
    }, _toDisplayString(phoneNumber.phone), 9, _hoisted_13)]), _createElementVNode("div", _hoisted_14, _toDisplayString(phoneNumber.type), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(phoneNumber.countries), 1)]);
  }), 128))]))], 64);
}